import { render, staticRenderFns } from "./MakePayment.vue?vue&type=template&id=45641a80&scoped=true&"
import script from "./MakePayment.vue?vue&type=script&lang=js&"
export * from "./MakePayment.vue?vue&type=script&lang=js&"
import style0 from "./MakePayment.vue?vue&type=style&index=0&id=45641a80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45641a80",
  null
  
)

export default component.exports